export default __webpack_public_path__ + "static/media/ps.21b3c1e0.svg";